import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RegistrationConfirmation from "../../componets/RegistrationConfirmation/RegistrationConfirmation";
import Started from "../../assets/gifs/started.gif";
import Food from "../../assets/gifs/food.gif";
import Ended from "../../assets/gifs/ended.gif";
import { logger } from "../../core/logger";
import AttendanceLayout from "../../componets/AttendanceLayout/AttendanceLayout";

type ActionKind = "entrada" | "salida-comer" | "termino-comida" | "salida";

const typesRegistration: Record<
  ActionKind,
  { title: string; successText: string; imageUrl?: string }
> = {
  entrada: {
    title: "¡Qué tengas un buen día!",
    successText: "Registro realizado con éxito",
    imageUrl: Started,
  },
  "salida-comer": {
    title: "¡Buen provecho!",
    successText: "Registro realizado con éxito",
    imageUrl: Food,
  },
  "termino-comida": {
    title: "¡Qué tengas un buen día!",
    successText: "Registro realizado con éxito",
    imageUrl: Started,
  },
  salida: {
    title: "¡Qué descanses!",
    successText: "Registro realizado con éxito",
    imageUrl: Ended,
  },
};

export default function SuccessfulRegistration() {
  const navigate = useNavigate();
  const { state } = useLocation() as {
    state?: { type?: ActionKind; employeeName?: string; timeISO?: string };
  };

  // const state = {
  //   type: "entrada" as ActionKind,
  //   employeeName: "Edith Núñez Pérez",
  // };
  const payload = useMemo(() => {
    const fromState = state && state.type && state.employeeName ? state : null;
    if (fromState) return fromState;
    try {
      const raw = sessionStorage.getItem("lastRegistration");
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed?.type && parsed?.employeeName && parsed?.timeISO) return parsed;
    } catch (e) {
      logger.error("Error parsing lastRegistration from sessionStorage", e);
    }
    return null;
  }, [state]);

  useEffect(() => {
    if (!payload) navigate("/", { replace: true });
  }, [payload, navigate]);

  if (!payload) return null;

  const type: ActionKind = payload.type as ActionKind;
  const def = typesRegistration[type] ?? typesRegistration.entrada;

  return (
    <AttendanceLayout imageSrc={def.imageUrl}>
      <RegistrationConfirmation
        employeeName={payload.employeeName}
        onExit={() => navigate("/", { replace: true })}
        title={def.title}
        successText={def.successText}
        imageUrl={def.imageUrl}
        autoCloseIn={16}
        exitPrefix="Volver al inicio"
      />
    </AttendanceLayout>
  );
}
